import {getTrips, getTopicsByJobIdApi, createTopicByJobId} from "./apiService";
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable';
import moment from "moment" ;


export const handleDownload = async (val , startTime, endTime, jsonToCSV) => {
  let resposne = await getTrips(1, 100, `0,1,2,4,3,5,6,7,8,9,10,13,18,20,21,22,31,32,33,34,35,36,37,38,39,40`, startTime ? moment.unix(startTime).format('YYYY-MM-DD') : undefined, endTime ? moment.unix(endTime).format('YYYY-MM-DD') : undefined)

  if (resposne.result.length === 0) {
    return false
  }
  if (val === 'pdf' && resposne.result.length > 0 ) {
    
    const doc = new jsPDF()
    //Generate Pdf from the Trip List
    let tableBody = []
    for (let trip of resposne.result) {
      let data = []
      data.push(trip.senderName)
      data.push(trip.startPlace)
      data.push(trip.receiverName)
      data.push(trip.endPlace)
      data.push(trip.price)
      tableBody.push(data)
    }

    autoTable(doc, {
      head: [['Sender Name', 'Sender Address', 'Receiver Name', 'Receiver Address', 'Price']],
      body: tableBody,
    })

    doc.save(`Triplist-${moment.unix(startTime).format('YYYY-MM-DD')}-${moment.unix(endTime).format('YYYY-MM-DD')}.pdf`)
    return true
  }

  if (val === 'csv' && resposne.result.length > 0) {
    
    let csvData = []
    for (let trip of resposne.result) { 
        csvData.push({
          'Sender Name' : trip.senderName,
          'Sender Address' : trip.startPlace,
          'Receiver Name' : trip.receiverName,
          'Receiver Address' : trip.endPlace,
          'Price' : trip.price,
        })
    }
    const results = jsonToCSV(csvData);
    const reader = new FileReader();
    reader.addEventListener('loadend', () => {
        const a = document.createElement('A');
        a.setAttribute('href', reader.result);
        a.setAttribute('download', `Triplist-${moment.unix(startTime).format('YYYY-MM-DD')}-${moment.unix(endTime).format('YYYY-MM-DD')}.csv`);

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    });
    reader.readAsDataURL(new Blob(['\ufeff' + results], { type: 'text/csv; charset=UTF-8' }));
    return true
  }
    
    
}

export const getTripCount = async (setTripCount, setShowSpinner) => {
  setShowSpinner(() => true)
  let allTrips = await getTrips(1, 25, `0,1,2,4,3,5,6,7,8,9,10,13,18,20,21,22,31,32,33,34,35,36,37,38,39,40`)
  let ongoingTrips = await getTrips(1, 25, `0,1,13,18,20,21,22,31,32,33,34,35,36,37,38,39`, moment().subtract(90, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
  let completedTrips = await getTrips(1, 25, `5,6,7,8,9,10,40`, moment().subtract(90, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
  
  setTripCount(() => {return {
    countAllBooking: allTrips.page.total ,
    countOngoingBooking : ongoingTrips.page.total ,
    countCompletedBooking : completedTrips.page.total ,
  }})
  setShowSpinner(() => false)

}

export const handleSelectedDate = async (userSelectedType , selectedTimeRange ,  setDeliveries,  setStartTime, setEndTime, startTime, endTime, setUserSelectedTab) => {
    
  //   setStartTime(moment().subtract(7, 'days').unix())
  //   setEndTime(moment().unix())

  // let pastTrips = await getTrips(1, 10, `5,6,7,8,9,10,40`, moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
  
  // setPastDeliveries(pastTrips)

  // return

  let selectedStartTime = startTime//moment().subtract(30, 'days').unix()
  let selectedEndTime   = endTime// moment().unix()

  if(selectedTimeRange) {
    
    selectedStartTime = selectedTimeRange[0].unix()
    selectedEndTime = selectedTimeRange[1].unix()
  }
  
  setStartTime(selectedStartTime)
  setEndTime(selectedEndTime)
  setUserSelectedTab(userSelectedType)

  if (userSelectedType  === 'all') {
    let trips = await getTrips(1, 15, `0,1,2,4,3,5,6,7,8,9,10,13,18,20,21,22,31,32,33,34,35,36,37,38,39,40`)
    
    setDeliveries(trips)
    return
  }
  
  if (userSelectedType  === 'on-going') {
    let trips = await getTrips(1, 15, `0,1,13,18,20,21,22,31,32,33,34,35,36,37,38,39`,  moment.unix(selectedStartTime).format('YYYY-MM-DD'), moment.unix(selectedEndTime).format('YYYY-MM-DD'))
    
    setDeliveries(trips)
    return
    
  }

  if (userSelectedType  === 'completed') {
    
    let trips = await getTrips(1, 15, `5,6,7,8,9,10,40`,  moment.unix(selectedStartTime).format('YYYY-MM-DD'), moment.unix(selectedEndTime).format('YYYY-MM-DD'))
    
    setDeliveries(trips)
    return
    
  }
}

export const handleTripPagination = async (status, pageNo, pageSize, setDeliveries, setPage) => {
  if (status  === 'all') {
    let tripList = await getTrips(pageNo+1, pageSize, `0,5,6,7,8,9,10,40`)
    if (tripList.result.length !== 0) {
      setDeliveries((trips) => { return { ...trips, result: [...trips.result, ...tripList.result]  }})
      setPage((page)=>{ return {...page, pageNumber: pageNo + 1 }})
    }
    return
  }
}

export const handleGetTopics = async (jobId , setRydeHelpTopicListForJobId) => {
  let response = await getTopicsByJobIdApi(jobId)
  setRydeHelpTopicListForJobId(response.result)
}

export const handleCreateTopic = async (data) => {
   let response = await createTopicByJobId(data)
   return response
}